export class LevelPageUnit {
  name: string;
  status: 'pending' | 'in_progress' | 'completed';
  thumbSrc?: string;
  type?: 'unit' | string;
  position?: number;
  description: string;
  description_es: string;
  'description_pt-BR': string;
  lessons: LessonsResponse[] | null;
  levelPosition: number;
}

export const getUnitListItemStatus = (unit: LevelPageUnit) => {
  if (unit.type === 'video') {
    return 'video';
  }

  switch (unit.status) {
    case 'in_progress':
      return 'current';
    case 'completed':
      return 'done';
    case 'pending':
    default:
      return 'blocked';
  }
};

export interface LevelResponse {
  data: Level;
}

export interface LevelsResponse {
  data: Level[];
}

export interface Level {
  id: number;
  type: string;
  position: number;
  current: boolean;
  title: string;
  status: string;
  eolTestAllowed: boolean;
  thumbSrc: null;
  requiredLiveClasses: number;
  completedLiveClasses: number;
  totalUnits: number;
  completedUnits: number;
  units: LevelPageUnit[];
}

interface LessonsResponse {
  data: Lesson[];
}

export interface LessonResponse {
  data: Lesson;
}

export interface Lesson {
  position: number;
  name: string;
  status: string;
  image: string;
  activity: string;
  playerUrl: string;
  playerLessonId: number;
  unitPosition: number;
  levelPosition: number;
  lessonPosition?: number;
}
